/**
 * Characters that change how a tag compares without changing how it looks (review B2).
 *
 * `female:lo<U+200B>licon` renders exactly like `female:lolicon`. Everything that compares or stores a tag
 * goes through this file so that such a character can neither hide a fixed-blocked name nor create a second,
 * identical-looking tag:
 *   - `normalizeTag` (policy/index.ts) removes them before any comparison;
 *   - the `Tag` schema (contract/primitives.ts) refuses a tag that contains one, at every API input;
 *   - the gdata parser (eh/gdata.ts) removes them from the tags it is about to hand over for storage.
 *
 * Covered: every "Other" category (control Cc, format Cf, surrogate Cs, private use Co, unassigned Cn),
 * every default-ignorable code point (zero-width joiners, variation selectors, the combining grapheme
 * joiner, Hangul fillers, tag characters) and the Braille blank. Visible look-alikes (letters of another
 * script, digits for letters) are NOT covered: they are different characters a person can see.
 */
const INVISIBLE_ONE = /[\p{C}\p{Default_Ignorable_Code_Point}\u2800]/u;
const INVISIBLE_ALL = /[\p{C}\p{Default_Ignorable_Code_Point}\u2800]/gu;

export function hasInvisibleCharacter(text: string): boolean {
  return INVISIBLE_ONE.test(text);
}

export function stripInvisibleCharacters(text: string): string {
  return text.replace(INVISIBLE_ALL, "");
}

/** A tag as it should be stored: invisible characters removed, no surrounding space. Case is kept. */
export function cleanTagText(tag: string): string {
  return stripInvisibleCharacters(tag).trim();
}
